import { FigureVarSettings, isFigureVarSettings } from "./FigureVarSettings";

export interface FigureAxisSettings {
  axisType: string;
  parameters: FigureVarSettings[];
}

/**
 * Type guard to check if an object is a FigureAxisSettings
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureAxisSettings
 */
export const isFigureAxisSettings = (obj: unknown): obj is FigureAxisSettings => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureAxisSettings;
  if (typeof chkObj.axisType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.parameters)) {
    return false;
  }
  if (chkObj.parameters.some((param) => !isFigureVarSettings(param))) {
    return false;
  }
  return true;
};
